@if (workflowPresets$ | async; as workflowPresets) {
  <selfai-platform-workflow-presets
    [currentWorkflowPreset]="workflowPresets"
    (backEvent)="onBack()"
    (submitEvent)="onSubmit($event)"
  ></selfai-platform-workflow-presets>
}
